var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgShopVisit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 7.48,13.57 L 6.86,12.74 L 5.26,13.21 L 4.45,10.99 L 5.97,10.31 L 5.92,9.28 L 6.04,8.26 L 4.57,7.48 L 5.53,5.32 L 7.1,5.89 L 7.77,5.12 L 8.58,4.48 L 8.06,2.89 L 10.25,2 L 10.98,3.5 L 12,3.42 L 13.02,3.5 L 13.75,2 L 15.94,2.89 L 15.42,4.48 L 16.23,5.12 L 16.9,5.89 L 18.47,5.32 L 19.43,7.48 L 17.96,8.26 L 18.08,9.28 L 18.03,10.31 L 19.55,10.99 L 18.74,13.21 L 17.14,12.74 L 16.52,13.57",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.14,7.55 L 11.14,5.84 A 0.86,0.86 -90 0,1 12.86,5.84 L 12.86,7.55 L 15.85,9.27 L 15.85,10.55 L 12.86,9.69 L 12.86,11.4 L 13.71,12.26 L 13.71,13.54 L 12,12.69 L 10.29,13.54 L 10.29,12.26 L 11.14,11.4 L 11.14,9.69 L 8.15,10.55 L 8.15,9.27 L 11.14,7.55",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.97,17.08 L 13.7,18.35 L 14.97,19.61 L 17.92,19.61 A 3.58,3.58 135 0,1 11.17,19.61 L 6.11,19.61 A 1.27,1.27 135 0,1 6.11,17.08 L 11.17,17.08 A 3.58,3.58 135 0,1 17.92,17.08 L 14.97,17.08",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShopVisit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shop-visit.ea7f0ad5.svg";
export { ForwardRef as ReactComponent };